<template>
  <div class="bn-cookie-banner cookie dark-theme" v-cloak :class="{ 'hide-cookie': hideCookie }">
    <div class="container">
      <div class="cookie-header">
        <div class="cookie--title">
          <span class="mdi--cookie"></span>
          <span>Cookies &amp; your privacy</span>
        </div>
        <span class="cookie--close" @click="acceptAll" title="Accept cookies">
          <md-icon>close</md-icon>
        </span>
      </div>
      <div class="cookie-info">
        <div class="cookie--content">
          <p class="cookie--lead">
            We use cookies and similar technologies to run the site, remember preferences, and (only with
            your permission) for analytics and marketing.
          </p>
          <p class="cookie--legal">
            <a href="/privacy-policy">Privacy Policy</a>
            <span class="cookie--legal-sep" aria-hidden="true">·</span>
            <a href="/terms-of-service">Terms of Service</a>
          </p>
        </div>

        <div v-if="advancedChoicesEnabled && showCustomize" class="cookie--customize">
          <p class="cookie--customize-intro">Optional cookies (off by default):</p>
          <div class="cookie--customize-opts" role="group" aria-label="Optional cookie categories">
            <md-checkbox v-model="optAnalytics" class="bn-cookie-opt">Analytics (usage insights)</md-checkbox>
            <md-checkbox v-model="optMarketing" class="bn-cookie-opt">Marketing &amp; social advertising</md-checkbox>
          </div>
        </div>

        <div class="cookie--actions">
          <div
            class="cookie--actions-primary"
            :class="{ 'cookie--actions-primary--single': !advancedChoicesEnabled }">
            <md-button
              v-if="advancedChoicesEnabled"
              type="button"
              class="md-button md-raised bn-cookie-reject-btn"
              @click="rejectNonEssential">
              Reject non-essential
            </md-button>
            <md-button
              type="button"
              class="md-button md-raised md-accent bn-cookie-alert-btn"
              @click="acceptAll">
              Accept all
            </md-button>
          </div>
          <div v-if="advancedChoicesEnabled" class="cookie--actions-secondary">
            <button type="button" class="bn-cookie-linkish" @click="toggleCustomize">
              {{ showCustomize ? 'Hide options' : 'Customize' }}
            </button>
            <md-button
              v-if="showCustomize"
              type="button"
              class="md-button md-raised md-accent bn-cookie-alert-btn bn-cookie-save-btn"
              @click="saveCustom">
              Save choices
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  writeConsentAcceptAll,
  writeConsentEssentialOnly,
  writeConsentCustom,
  applyConsentedClass,
  readConsent,
} from 'utils/cookie-consent'

// Temporary kill-switch until dashboard preferences exist.
// Flip to `true` when ready to expose Customize/Reject.
const ENABLE_COOKIE_ADVANCED_CHOICES = false

export default {
  name: 'CookieMessage',
  data () {
    return {
      hideCookie: true,
      showCustomize: false,
      optAnalytics: false,
      optMarketing: false,
    }
  },
  computed: {
    advancedChoicesEnabled () {
      return ENABLE_COOKIE_ADVANCED_CHOICES
    },
  },
  methods: {
    acceptAll () {
      try {
        writeConsentAcceptAll()
      } catch (e) {
        /* private mode */
      }
      applyConsentedClass()
      this.$emit('consent', readConsent())
      this.$emit('close')
    },
    rejectNonEssential () {
      try {
        writeConsentEssentialOnly()
      } catch (e) {
        /* private mode */
      }
      applyConsentedClass()
      this.$emit('consent', readConsent())
      this.$emit('close')
    },
    saveCustom () {
      try {
        writeConsentCustom({
          analytics: this.optAnalytics,
          marketing: this.optMarketing,
        })
      } catch (e) {
        /* private mode */
      }
      applyConsentedClass()
      this.$emit('consent', readConsent())
      this.$emit('close')
    },
    toggleCustomize () {
      this.showCustomize = !this.showCustomize
    },
  },
}
</script>
